var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      ref: "block",
      staticClass: "cw-block cw-block-embed",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: false,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title",
                        },
                        [_vm._v(_vm._s(_vm.currentTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.oembedData !== null
                    ? _c("div", [
                        _vm.oembedData.type === "rich" ||
                        _vm.oembedData.type === "video"
                          ? _c("div", {
                              staticClass: "cw-block-embed-iframe-wrapper",
                              style: {
                                height: _vm.contentHeight + "px",
                              },
                              domProps: {
                                innerHTML: _vm._s(_vm.oembedData.html),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.oembedData.type === "photo"
                          ? _c(
                              "div",
                              {
                                style: {
                                  height: _vm.contentHeight + "px",
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.oembedData.url,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.oembedData.type === "link" &&
                        _vm.oembedData.provider_name === "DeviantArt"
                          ? _c("div", [
                              _c("img", {
                                attrs: {
                                  src: _vm.oembedData.fullsize_url,
                                },
                              }),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.oembedData !== null
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-embed-info",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "cw-block-embed-title",
                            },
                            [_vm._v(_vm._s(_vm.oembedData.title))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "cw-block-embed-author-name",
                            },
                            [
                              _c("translate", [_vm._v("erstellt von")]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.oembedData.author_url,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.oembedData.author_name))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "cw-block-embed-source",
                            },
                            [
                              _c("translate", [_vm._v("veröffentlicht auf")]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.oembedData.provider_url,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.oembedData.provider_name))]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Überschrift")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTitle,
                                    expression: "currentTitle",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentTitle,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentTitle = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Quelle")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentSource,
                                      expression: "currentSource",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentSource = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                _vm._l(_vm.endPoints, function (value, key) {
                                  return _c(
                                    "option",
                                    {
                                      key: key,
                                      domProps: {
                                        value: key,
                                      },
                                    },
                                    [_vm._v(_vm._s(key))]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("URL")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentUrl,
                                    expression: "currentUrl",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentUrl,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentUrl = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.currentSource === "youtube"
                            ? _c(
                                "label",
                                [
                                  _c("translate", [
                                    _vm._v("Startpunkt wählen"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.currentStartTime,
                                        expression: "currentStartTime",
                                      },
                                    ],
                                    attrs: {
                                      type: "time",
                                      step: "1",
                                      min: "00:00:00",
                                      max: "24:00:00",
                                    },
                                    domProps: {
                                      value: _vm.currentStartTime,
                                    },
                                    on: {
                                      change: _vm.updateTime,
                                      input: function input($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.currentStartTime =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentSource === "youtube"
                            ? _c(
                                "label",
                                [
                                  _c("translate", [_vm._v("Endpunkt wählen")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.currentEndTime,
                                        expression: "currentEndTime",
                                      },
                                    ],
                                    attrs: {
                                      type: "time",
                                      step: "1",
                                      min: _vm.currentStartTime,
                                      max: "24:00:00",
                                    },
                                    domProps: {
                                      value: _vm.currentEndTime,
                                    },
                                    on: {
                                      change: _vm.updateTime,
                                      input: function input($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.currentEndTime = $event.target.value
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c(
                    "p",
                    [
                      _c("translate", [
                        _vm._v("Informationen zum Embed-Block"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }